import { render, staticRenderFns } from "./disclaimerClausePopUpBox.vue?vue&type=template&id=3f9dae8e&scoped=true"
import script from "./disclaimerClausePopUpBox.vue?vue&type=script&lang=js"
export * from "./disclaimerClausePopUpBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9dae8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f9dae8e')) {
      api.createRecord('3f9dae8e', component.options)
    } else {
      api.reload('3f9dae8e', component.options)
    }
    module.hot.accept("./disclaimerClausePopUpBox.vue?vue&type=template&id=3f9dae8e&scoped=true", function () {
      api.rerender('3f9dae8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/leftMoudle/dialog/disclaimerClausePopUpBox.vue"
export default component.exports